module.exports = __webpack_public_path__ + "img/melontareitti_original.c273b127.png";